class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    if (this.continueShoppingBtn) {
      this.continueShoppingBtn.addEventListener('click', this.close.bind(this));
    }
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    const clearConfirmPopup = this.querySelector('.cart-warning-popup');
    if(clearConfirmPopup) clearConfirmPopup.classList.add('hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id || parsedState.items?.[0]?.id; //Or condition for frequently bought together products 
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.querySelector('.continue-shopping').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class CustomRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
  }

  connectedCallback() {
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.removeBundleFromCart();
    });
  }

  removeBundleFromCart() {
    const removeButton = this.querySelector("button");

    if (!removeButton || !removeButton.dataset.bundleVariantIds) {
      console.error("Missing data-bundle-variant-ids on button");
      return;
    }

    const variantIds = removeButton.dataset.bundleVariantIds.split(',').map(id => id.trim()).filter(id => id !== "");

    if (variantIds.length === 0) return;

    const updates = {};
    variantIds?.forEach(variantId => {
      updates[variantId] = 0;
    });

    const payload = {
      updates,
      sections: this.cart.getSectionsToRender().map(section => section.id),
      sections_url: window.location.pathname
    };
    console.log(payload)

    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(payload),
    })
    .then(response => response.json())
    .then(data => {
      if (data.item_count === 0) {
        this.cart?.classList.add("is-empty");
      }
      this.cart?.renderContents(data);
    })
    .catch(error => {
      console.error("Error updating cart:", error.message);
    });
  }
}

customElements.define("custom-remove-button", CustomRemoveButton);


class CartClearButton extends HTMLElement {
  constructor(){
    super();
    this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    this.cartClearBtn = this.querySelector(".cart-clear-button");
    this.confirmationPopup = this.querySelector(".cart-warning-popup");
    this.clearConfirmButton = this.querySelector(".confirm-clear");
    this.clearCancelButton = this.querySelector(".cancel-clear");
  }

  connectedCallback(){
    if (!this.cartClearBtn) return;

    this.cartClearBtn.addEventListener('click', this.showConfirmationPopup.bind(this));
    this.clearConfirmButton.addEventListener('click', this.clearCart.bind(this));
    this.clearCancelButton.addEventListener('click', this.closeConfirmationPopup.bind(this))
  }

  showConfirmationPopup(){
    this.confirmationPopup?.classList.remove('hidden');
  }

  clearCart(){
    const payload = {
      sections: this.cart.getSectionsToRender().map(section => section.id),
      sections_url: window.location.pathname
    };

    fetch('/cart/clear.js', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(payload)
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      if (data.item_count === 0) {
        this.cart?.classList.add("is-empty");
      }
      this.cart?.renderContents(data);
      this.confirmationPopup.classList.add('hidden');
    })
    .catch(error => {
      console.error("Error updating cart:", error.message);
      this.confirmationPopup.classList.add('hidden');
    })
  }

  closeConfirmationPopup(){
    this.confirmationPopup.classList.add('hidden');
  }
}

customElements.define('cart-clear-button', CartClearButton);